<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="gps-acoordion">
    <div class="dash-gps-top">
      <button
        type="button"
        class="button buttonBlue mr-3 fixed-btn"
        (click)="addGPSType('New', null)"
        *ngIf="addBtn"
      >
        <img
          class="drivers-head-img"
          src="../../../assets/img/plus-white.svg"
        />
        Add
      </button>
      <button
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          class="search pl-2"
          placeholder="Server Name"
          id="ServerName"
          #newItem
          (keyup)="onInputChange(newItem.value)"
        />
        <img
          class="search_number"
          *ngIf="search_btn"
          (click)="search(newItem.value)"
          src="../../../assets/img/search-white.svg"
        />
        <button
          *ngIf="clear_Btn"
          class="search_number1"
          (click)="resetSearch()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="search_icon"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div [class.spinner]="loading"></div>
  <div class="row to_container" *ngIf="!GpsTypeData?.length && !loading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div class="gps" *ngIf="!GPSType">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="_id">
          <th mat-header-cell *matHeaderCellDef>ID.</th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="addGPSType('Edit', element)"
          >
            {{ element._id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="server_name">
          <th mat-header-cell *matHeaderCellDef>Server Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.server_name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="server_url">
          <th mat-header-cell *matHeaderCellDef>Server URL</th>
          <td mat-cell *matCellDef="let element">{{ element.server_url }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Created Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAt | date : "dd-MM-yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
          <th mat-header-cell *matHeaderCellDef>Updated Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAt | date : "dd-MM-yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <img
              class="drivers-head-img"
              src="../../../assets/img/delete.svg"
              (click)="DeleteGpsType(element._id)"
            />
            <img
              class="drivers-head-img"
              src="../../../assets/img/edit_icon1.png"
              (click)="editGpsType(element)"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('-1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('first')"
        >
          <img
            src="../../../assets/img/pagination-left.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <div class="pages">
          <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
        </div>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('last')"
        >
          <img
            src="../../../assets/img/pagination-right.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap=" round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
